import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle, X } from 'lucide-react';

/**
 * BrandGate - Shows floating warning if brand setup incomplete
 */
const BrandGate = ({ brandSetupComplete, children }) => {
  const [dismissed, setDismissed] = React.useState(false);
  
  return (
    <>
      {children}
      {/* Floating warning at bottom-left */}
      {brandSetupComplete === false && !dismissed && (
        <div className="fixed bottom-4 left-4 z-50 max-w-sm animate-in slide-in-from-left">
          <div className="bg-gray-900/95 backdrop-blur-sm border border-yellow-500/50 rounded-lg shadow-xl p-4">
            <div className="flex items-start gap-3">
              <AlertTriangle className="w-5 h-5 text-yellow-400 flex-shrink-0 mt-0.5" />
              <div className="flex-1">
                <p className="text-sm text-gray-200 mb-2">
                  Los resultados pueden ser imprecisos sin perfil de marca.
                </p>
                <Link 
                  to="/brand-setup" 
                  className="text-sm text-yellow-400 hover:text-yellow-300 font-medium"
                >
                  Completar perfil →
                </Link>
              </div>
              <button 
                onClick={() => setDismissed(true)}
                className="text-gray-500 hover:text-gray-300 p-1"
                aria-label="Cerrar"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default BrandGate;
